import React from 'react';
import Home from './Home/Home';
import Registrasi from './Registrasi/Registrasi';
import Layanan from './Layanan/Layanan';
import Privasi from './Layanan/Privasi';
import Kontak from './Layanan/Kontak';
import Faq from './Layanan/Faq';
import RegistrasiFood from './Registrasi/RegistrasiFood';
import Coba from './Coba'
import {Switch, Route} from 'react-router-dom';

const Main =() => (
  <main>
     <Switch>
      <Route exact path="/" component={Home} ></Route>
      <Route path="/registrasi" component={Registrasi} ></Route>
      <Route path="/registrasifood" component={RegistrasiFood} ></Route>
      <Route path="/layanan" component={Layanan} ></Route>
      <Route path="/privasi" component={Privasi} ></Route>
      <Route path="/faq" component={Faq} ></Route>
      <Route path="/kontak" component={Kontak} ></Route>
    </Switch>
 
  </main>
)


export default Main;